<template>
  <div class="post type-post hentry">
    <h2>
      <router-link
        to="/2010/12/sakiuose-ikurtas-krikscioniu-partijos-skyrius"
        >Šakiuose įkurtas Krikščionių partijos skyrius</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Gruodžio</span><span class="date_nr">30</span>
    </div>
    <div class="entry">
      <p>
        Šakiuose atidarytas dar vienas Krikščionių partijos skyrius. Prie
        puodelio arbatos apie miestą riečiančias problemas susirinko pasikalbėti
        nemažas būrys šakiškių bei Seimo narys Jonas Ramonas, Krikščionių
        partijos generalinis sekretorius Albinas Pilipauskas, administracijos
        direktorius Arnoldas Žvikas. „Skaidrumo kol kas mūsų miesto valdyme nėra
        ir Šakiams tikrai reikia permainų“,- teigė šakiškis Romualdas Damušis,
        vėliau vienbalsiai išrinktas įkurto Krikščionių partijos Šakių skyriaus
        pirmininku.
      </p>
      <p>
        Sveikindamas naujo skyriaus narius parlamentaras Jonas Ramonas kvietė
        visus miestelėnus jungtis prie Krikščionių partijos ir taip keisti
        Lietuvą. „Kviečiu visus susitelkti ir kalbėtis, o taip pat siūlyti. Tik
        dirbdami kartu mes galime pakeisti Lietuvą“, – sakė Krikščionių partijos
        frakcijos Seime narys.
      </p>
      <p>
        Šiuo metu Krikščionių partijai priklauso beveik 8000 žmonių iš visos
        Lietuvos.
      </p>
      <p>Nuotraukos:</p>
      <p>
        <img
          class="alignnone"
          src="/assets/ikurtas_skyrius1.jpg"
          alt="pirma"
          width="354"
          height="265"
        />
      </p>
      <p>
        <img
          class="alignnone"
          src="/assets/ikurtas_skyrius2.jpg"
          alt="antra"
          width="354"
          height="265"
        />
      </p>
      <p>
        <img
          class="alignnone"
          src="/assets/ikurtas_skyrius3.jpg"
          alt="trecia"
          width="353"
          height="265"
        />
      </p>
    </div>
  </div>
</template>
